export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  tag: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  cover: string;
  summary: string;
  content: string[];
  relatedMangaIds: number[];
  hot?: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026 秋季新番漫画盘点：这 10 部绝对不能错过',
    slug: '2026-fall-new-comics',
    category: '漫画盘点',
    tag: '新番推荐',
    author: '漫迹编辑部',
    date: '2026-08-10',
    readTime: '8 分钟',
    views: 45200,
    cover: 'https://readdy.ai/api/search-image?query=stylized%20banner%20illustration%20of%20a%20stack%20of%20colorful%20manga%20volumes%20with%20stars%20and%20sparkles%2C%20warm%20orange%20and%20amber%20palette%2C%20playful%20editorial%20style%2C%20clean%20graphic%20composition%2C%20no%20text&width=1200&height=675&seq=article-cover-01&orientation=landscape',
    summary: '从热血到治愈，本季新作漫画百花齐放。编辑部精挑细选 10 部高潜力作品，助你追更不迷路。',
    content: [
      '每年秋季都是漫画新作的井喷期。今年也不例外，无论是王道热血、悬疑烧脑还是清新治愈，都有值得期待的作品登场。编辑部花了整整一周时间试读筛选，最终从上百部新连载中挑出了这 10 部最值得关注的潜力之作。',
      '首先不得不提的是《星穹剑鸣录》，它把修仙与剑道完美融合，打斗分镜干净利落，世界观铺垫也相当扎实，开篇三话就牢牢抓住了读者的心，本周更新已经冲到热搜榜第一。',
      '如果你是悬疑爱好者，《雾都谜案》绝对会让你欲罢不能。雾都的设定氛围感十足，每一话都在抛出新的谜题，同时又悄悄埋下伏笔，让人忍不住一口气追完。',
      '恋爱番方面，《春日里的告白》用细腻的笔触描绘了青春里最动人的心动瞬间，画面柔和，情绪到位，是许多读者本季的"恋爱脑"首选。',
      '当然，追更最重要的还是别错过更新。你可以使用我们的漫画更新提醒功能，为心仪的作品设置追更，一旦最新话更新就会第一时间推送给你，从此再也不怕错过精彩章节。',
      '以上只是 10 部中的一小部分，完整榜单请继续往下看，每一部都附上了推荐理由与追更建议。无论你的口味如何，相信总有一部能击中你的心。',
    ],
    relatedMangaIds: [1, 2, 4, 9],
    hot: true,
  },
  {
    id: 2,
    title: '追更党的福音：如何高效管理你的漫画追更清单',
    slug: 'how-to-manage-manga-list',
    category: '追更攻略',
    tag: '实用技巧',
    author: '追更小能手',
    date: '2026-08-08',
    readTime: '6 分钟',
    views: 38900,
    cover: 'https://readdy.ai/api/search-image?query=clean%20flat%20illustration%20of%20a%20person%20using%20a%20smartphone%20with%20a%20colorful%20reading%20list%20and%20bell%20notification%20icons%20floating%20around%2C%20warm%20orange%20and%20teal%20palette%2C%20modern%20minimal%2C%20no%20text&width=1200&height=675&seq=article-cover-02&orientation=landscape',
    summary: '同时追十几部漫画，总怕漏掉更新？掌握这 5 个方法，让你的追更清单井井有条。',
    content: [
      '追的漫画一多，就很容易顾此失彼：有的忘看最新话，有的更新了都不知道。作为一个资深追更党，我总结了一套高效的追更管理方法，分享给大家。',
      '第一步，给你的追更清单分级。把最在意、更新最勤的作品设为"重点关注"，其余的按更新频率分组。这样每天打开清单，先看重点作品，效率翻倍。',
      '第二步，善用漫画更新日历。很多作品都有固定的更新时间，提前了解它们的更新规律，就能大致预判哪天有新话，避免无意义的反复刷新。',
      '第三步，也是最重要的一步，就是开启漫画最新话推送。与其每天手动去一个个翻，不如让工具替你做这件事。一旦关注的作品更新，第一时间就能收到通知，绝不遗漏。',
      '第四步，定期清理"僵尸追更"。有些作品长期不更新或已经完结，把它们移出清单，能给真正在追的作品留出更多注意力。',
      '最后，别忘了加入追更社区和大家一起交流。和同好分享追更进度、讨论剧情走向，会让追更这件事变得更有趣、更有成就感。',
    ],
    relatedMangaIds: [6, 5, 3],
  },
  {
    id: 3,
    title: '新读者入门指南：从零开始搭建你的漫画追更工具库',
    slug: 'beginner-guide-manga-tracking',
    category: '新手入门',
    tag: '新手教程',
    author: '漫迹编辑部',
    date: '2026-08-05',
    readTime: '5 分钟',
    views: 27300,
    cover: 'https://readdy.ai/api/search-image?query=welcoming%20flat%20illustration%20of%20a%20newcomer%20reading%20manga%20with%20helpful%20guide%20icons%2C%20star%20and%20arrow%20elements%2C%20warm%20orange%20and%20cream%20palette%2C%20friendly%20modern%20style%2C%20no%20text&width=1200&height=675&seq=article-cover-03&orientation=landscape',
    summary: '第一次接触漫画追更工具？别担心，这篇入门指南带你一步步上手，开启顺畅的追更之旅。',
    content: [
      '刚接触漫画追更的你，可能面对满屏的功能有些无从下手。别担心，这篇指南会带你从零开始，一步步搭建属于你自己的漫画追更工具库。',
      '第一步，先熟悉漫画追更工具的界面。你会在首页看到热门连载、最新更新、更新日历等模块。多浏览几遍，了解每个入口是做什么的，这是上手最快的办法。',
      '第二步，学会使用漫画连载进度查询。当你看到一部感兴趣的作品，点进去就能看到它的最新话、更新频率、连载状态等关键信息，快速判断它是否值得追。',
      '第三步，开始建立你的追更清单。把感兴趣的漫画收藏起来，并设置为追更提醒。之后只要作品更新，你就会第一时间收到最新话推送。',
      '第四步，多逛逛漫画更新日历。日历能帮你总览每周的更新安排，还能发现那些"今天正好更新"的作品，是发现新番的好去处。',
      '最后，欢迎加入追更社区。在这里你可以提问、分享、结识同好。追更路上不孤单，和志同道合的伙伴一起，才是追更最大的乐趣。',
    ],
    relatedMangaIds: [1, 6, 10],
  },
  {
    id: 4,
    title: '编辑部独家专访：《沙雕室友观察日记》创作背后的故事',
    slug: 'interview-shadiao-roommate',
    category: '行业专访',
    tag: '独家',
    author: '漫迹记者站',
    date: '2026-08-01',
    readTime: '10 分钟',
    views: 51200,
    cover: 'https://readdy.ai/api/search-image?query=stylized%20interview%20scene%20illustration%20with%20a%20cute%20cartoon%20creator%20behind%20a%20desk%20surrounded%20by%20sketchbooks%20and%20comic%20panels%2C%20warm%20yellow%20and%20orange%20palette%2C%20cozy%20playful%20style%2C%20no%20text&width=1200&height=675&seq=article-cover-04&orientation=landscape',
    summary: '《沙雕室友观察日记》作者咸鱼君接受独家专访，畅谈创作灵感、追更社区互动与未来计划。',
    content: [
      '《沙雕室友观察日记》凭借轻松搞笑的风格，在追更社区里人气一路飙升，粉丝数已突破 30 万。今天，我们有幸邀请到作者"咸鱼君"进行独家专访，聊聊这部作品的创作之路。',
      '咸鱼君告诉我们，《沙雕室友观察日记》的灵感其实来自他自己的大学宿舍生活。"那些看似无聊的日常，在插科打诨的室友衬托下，反而成了最好的素材。"他笑着说。',
      '关于追更社区，咸鱼君特别感谢了读者们的支持。"很多读者会在社区里分享自己的宿舍趣事，这给了我源源不断的灵感。追更社区不仅是追更的地方，更是创作者和读者沟通的桥梁。"',
      '当被问及未来的剧情走向，咸鱼君卖了个关子："新室友已经登场了，后续会有一段非常热闹的戏份，敬请期待，记得开启更新提醒别错过哦。"',
      '最后，咸鱼君对漫画追更工具表达了肯定："追更工具让读者能第一时间看到新内容，创作者也能更快得到反馈，这是双赢。"',
    ],
    relatedMangaIds: [6],
    hot: true,
  },
  {
    id: 5,
    title: '2026 上半年追更报告：哪些漫画最受欢迎？',
    slug: '2026-h1-report',
    category: '数据报告',
    tag: '热门榜',
    author: '数据喵',
    date: '2026-07-28',
    readTime: '7 分钟',
    views: 36100,
    cover: 'https://readdy.ai/api/search-image?query=modern%20data%20report%20illustration%20with%20rising%20charts%2C%20rankings%20and%20a%20trophy%20icon%20over%20manga%20book%20icons%2C%20warm%20orange%20and%20teal%20palette%2C%20clean%20infographic%20style%2C%20no%20text&width=1200&height=675&seq=article-cover-05&orientation=landscape',
    summary: '结合全站追更数据，为你盘点 2026 上半年最受欢迎、增长最快的漫画作品。',
    content: [
      '又到了半年一度的数据盘点时间。我们结合全站数百万条追更数据，为大家带来了 2026 上半年的追更报告，看看这半年里到底哪些漫画最受追更党的青睐。',
      '在热度榜上，《星穹剑鸣录》凭借稳定的更新节奏和高口碑，牢牢占据榜首，追更人数持续攀升，是当之无愧的人气王。',
      '增长最快的作品则要数《机械之心》，赛博朋克的世界观加上出色的画面表现，让它在年轻读者中迅速走红，半年内追更人数翻了近三倍。',
      '搞笑日常类作品依然强势，《沙雕室友观察日记》和《超能力日常社》都进入了热度前十，说明轻松解压的内容始终是刚需。',
      '这份报告还揭示了几个有趣的现象：越来越多的读者开始同时使用漫画更新日历和最新话推送功能，追更的效率和体验都在明显提升。',
      '下一份半年报告，我们会在年底与大家见面。如果你想知道哪些作品值得追，不妨多关注我们的热门榜单和追更数据。',
    ],
    relatedMangaIds: [1, 10, 6, 11],
  },
];